import { useAlbumStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";

const Option = observer(() => {
  const albumStore = useAlbumStore();


  return (
    <>
      <main className="container mx-auto p-4">
        <section>
          <h2>Explorez notre collection d'œuvres</h2>
        </section>
      </main>
    </>
  );
})

export default Option;
